module.exports = __webpack_public_path__ + "static/media/tax-default-icon.1921bc71.png";